import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuardService } from '../authentication/auth-guard.service';
import { ProjectCommitsComponent } from './project-commits/project-commits.component';
import { RouterModule } from '@angular/router';
import { DropdownModule, RadioButtonModule, CardModule, ChartModule, TabViewModule } from 'primeng/primeng';
import { FormsModule } from '@angular/forms';
import { MatRadioModule, MatTabsModule, MatCardModule, MatIconModule, MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatMenuModule, MatRippleModule, MatToolbarModule, MatTableModule, MatOptionModule, MatSelectModule, MatAutocompleteModule } from '@angular/material';
import { TableModule } from 'primeng/table';
import { GridProjectCommitsComponent } from './common/grid-project-commits/grid-project-commits.component';
import { GridReopenedContributionComponent } from './common/grid-reopened-contribution/grid-reopened-contribution.component';
import { GridPushedContributionComponent } from './common/grid-pushed-contribution/grid-pushed-contribution.component';
import { GridMergedContributionComponent } from './common/grid-merged-contribution/grid-merged-contribution.component';
import { GridCreatedContributionComponent } from './common/grid-created-contribution/grid-created-contribution.component';
import { GridCommentedContributionComponent } from './common/grid-commented-contribution/grid-commented-contribution.component';
import { GridClosedContributionComponent } from './common/grid-closed-contribution/grid-closed-contribution.component';

const routes = [
  { path: 'projects-commit', component: ProjectCommitsComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  declarations: [
    ProjectCommitsComponent,
    GridProjectCommitsComponent,
    GridClosedContributionComponent,
    GridCommentedContributionComponent,
    GridCreatedContributionComponent,
    GridMergedContributionComponent,
    GridPushedContributionComponent,
    GridReopenedContributionComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),

    DropdownModule,
    RadioButtonModule,
    FormsModule,
    CardModule,
    ChartModule,
    TabViewModule,
    MatRadioModule,
    MatTabsModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatRippleModule,
    MatTableModule,
    MatToolbarModule,
    MatOptionModule,
    MatSelectModule,
    MatAutocompleteModule,
    TableModule
  ]
})
export class GitlabReportModule { }
